import { useEffect, useState } from "react";
import { API_BASE, apiFile } from "../lib/api";

const BUILT_IN = [
  { src: "/logos/finest-cuts.webp", alt: "Finest Cuts Israel", invert: false, lift: false, size: "normal" },
  { src: "/logos/album-creative.webp", alt: "alBum Creative", invert: false, lift: true, size: "normal" },
  { src: "/logos/laser-by-chava.webp", alt: "Laser by Chava", invert: false, lift: false, size: "normal" },
  { src: "/logos/camp-horizon.webp", alt: "Camp Horizon", invert: false, lift: false, size: "normal" },
  { src: "/logos/suited-london.webp", alt: "Suited London", invert: true, lift: false, size: "normal" },
  { src: "/logos/embellish.webp", alt: "Embellish", invert: true, lift: false, size: "normal" },
  { src: "/logos/chap-a-ride.webp", alt: "Chap a Ride", invert: true, lift: false, size: "normal" },
  { src: "/logos/wigline.webp", alt: "Wigline by Freidy Lindner", invert: false, lift: false, size: "normal" },
  { src: "/logos/relish.webp", alt: "Relish", invert: false, lift: false, size: "normal" },
  { src: "/logos/sesame-kingdom.webp", alt: "Sesame Kingdom", invert: true, lift: false, size: "normal" },
  { src: "/logos/rulop.webp", alt: "Rulop Foods", invert: false, lift: false, size: "normal" },
  { src: "/logos/furnisure.webp", alt: "Furnisure", invert: false, lift: true, size: "normal" },
  { src: "/logos/acm-group.webp", alt: "ACM Group UK", invert: false, lift: false, size: "normal" },
  { src: "/logos/fullis.webp", alt: "Fulli's Hygiene & Janitorial Supplies", invert: false, lift: false, size: "small" },
];

const SIZE_CLASS = {
  small: "h-9 md:h-11",
  normal: "h-24 md:h-32",
  large: "h-28 md:h-40",
};

const toLogo = (l) => ({
  src: (l.src || "").startsWith("/") ? l.src : apiFile(l.src),
  alt: l.alt || "Client logo",
  invert: !!l.invert,
  lift: !!l.lift,
  h: SIZE_CLASS[l.size] || SIZE_CLASS.normal,
});

const Row = ({ ariaHidden = false, logos }) => (
  <div aria-hidden={ariaHidden} className="flex shrink-0 items-center">
    {logos.map((logo) => (
      <span key={logo.alt + logo.src} className="flex items-center">
        <img
          src={logo.src}
          alt={ariaHidden ? "" : logo.alt}
          loading="lazy"
          data-testid={`client-logo-${logo.alt.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className={`${logo.h} w-auto max-w-[400px] object-contain mix-blend-screen md:max-w-[540px]`}
          style={
            logo.invert
              ? { filter: "invert(1)" }
              : logo.lift
                ? { filter: "brightness(1.75)" }
                : undefined
          }
        />
        <span className="mx-8 h-1.5 w-1.5 rotate-45 bg-vermilion md:mx-12" />
      </span>
    ))}
  </div>
);

export default function LogoBanner() {
  const [logos, setLogos] = useState(BUILT_IN.map(toLogo));

  useEffect(() => {
    let alive = true;
    fetch(`${API_BASE}/api/logos`)
      .then((r) => (r.ok ? r.json() : []))
      .then((list) => {
        if (alive && Array.isArray(list) && list.length) setLogos(list.map(toLogo));
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  return (
    <div data-testid="logo-banner" className="mb-12 border-y border-white/10 py-8 md:mb-14 md:py-10">
      <p className="mb-4 text-center font-mono text-[9px] uppercase tracking-[0.3em] text-neutral-600">
        You&rsquo;re in good company
      </p>
      <div className="overflow-hidden">
        <div className="marquee-track flex w-max" style={{ animationDuration: "40s" }}>
          <Row logos={logos} />
          <Row ariaHidden logos={logos} />
        </div>
      </div>
    </div>
  );
}